import HeaderSubPage from 'components/HeaderSubPage';
import Paragraph from 'components/paragraphs/Paragraph';
import { absoluteUrl } from 'lib/utils';
import { DrupalNode, DrupalParagraph } from 'next-drupal';

interface NodeNewsProps {
  node: DrupalNode;
}

export default function NodeNews({ node, ...props }: NodeNewsProps) {
  return (
    <article {...props} className="bg-tertiary">
      <HeaderSubPage
        title={null}
        imageUrl={absoluteUrl(
          node?.field_teaser_image?.field_media_image?.uri?.url
        )}
        imageAlt={
          node?.field_teaser_image?.field_media_image?.resourceIdObjMeta?.alt
        }
        videoUrl=""
      />
      {node?.field_content?.map((paragraph: DrupalParagraph) => {
        return <Paragraph key={paragraph.id} paragraph={paragraph} />;
      })}
      {node?.body?.processed && (
        <div
          className="prose mx-auto max-w-6xl px-5 py-10 lg:px-0 lg:py-32"
          dangerouslySetInnerHTML={{ __html: node.body.processed }}
        ></div>
      )}
    </article>
  );
}
